import { Validators } from '@angular/forms';
import { FormConfig } from '../edit-create-form.interfaces';

export const leadCampaignFormConfig = (): FormConfig => {
  return {
    fields: [
      {
        key: 'id', label: 'ID', type: 'text', width: 'full', hidden: true
      },
      {
        key: 'code', label: 'Mã campaign', required: true, width: 'half',
        type: 'text', placeholder: 'Nhập mã campaign',
        customErrorMessage: 'Mã campaign là bắt buộc'
      },
      {
        key: 'name', label: 'Tên campaign', required: true, width: 'half',
        type: 'text', placeholder: 'Nhập tên campaign',
        customErrorMessage: 'Tên campaign là bắt buộc'
      },
      {
        key: 'date', label: 'Ngày', required: false, width: 'half',
        type: 'datepicker', placeholder: 'Chọn ngày'
      }
    ]
  };
};

